// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"f8503dcd","172":"f8503dcd","729":"f8503dcd"}[chunkId] + ".chunk.css";
};